import React, { Fragment, Component } from 'react';

class CloseTutionFeeChalanFormForMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <Fragment>
              <div style={{ padding: 50}}>Invalid to get challan form,  Please close the browser and Re-Login to your mobile app then try again, If you facing still this issue then <br/> Contact IT support and admin</div>
            </Fragment >
        );
    }
}

export default CloseTutionFeeChalanFormForMobile;